import { Component, Input } from '@angular/core';

@Component({
  selector: 'ling-page-main-area',
  templateUrl: './page-main-area.component.html',
  styleUrls: ['./page-main-area.component.scss'],
})
export class PageMainAreaComponent {
  @Input() title = '';
}
